module.exports = __webpack_public_path__ + "img/banner3_1_vi.eb4689bf.png";